import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Card, Accordion } from 'react-bootstrap';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import SimpleReactValidator from 'simple-react-validator';
import { userActions } from '../../../../../common/redux/actions';

class Kids extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formField: {
                name: "",
                age: "",
                grade: "",
                description: "",
            },
            toggleChild: false,
            item: null
        };
        this.resetState = this.state.formField;
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    componentDidMount() {
        const { dispatch, childs } = this.props;
        childs && childs.childs && childs.childs.length === 0 && dispatch(userActions.child());
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({formField});
    };

    resetForm = () => {
        this.setState({formField: this.resetState, item: null, toggleChild: false});
    }

    addNew = () => {
        this.setState({ formField: this.resetState, item: null, toggleChild: true})
    }

    onDelete = (id) => {
        const { dispatch } = this.props;
        dispatch(userActions.child("DELETE", null, {item_id: id}));
    }

    onEdit = (item) => {
        let formField = { ...this.state.formField };
        formField['name'] = item.name;
        formField['age'] = item.age;
        formField['grade'] = item.grade;
        formField['description'] = item.description;
        this.setState({formField, item, toggleChild: true});
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { formField, item } = this.state;
        if(this.validator.allValid()) {
            const { dispatch } = this.props;
            const item_id = (item !== null) ? {item_id: item.id} : null;
            dispatch(userActions.child("POST", {userChild: formField}, item_id));
            let vm = this;
            setTimeout(function(){
                vm.resetForm();
            }, 1200);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    
    render() {
        this.validator.purgeFields();
        const { formField, toggleChild, item } = this.state;
        const { childs } = this.props;
        const childItems = (childs && childs.childs) ? childs.childs : [];
        //console.log('childs', childs);
        return (<div className="experience">
            <Card.Title className="d-flex align-items-center justify-content-between">
                <h3 className="page-subtitle mb-0">Kids Information</h3>
                <button onClick={this.addNew} className="btn btn-purpul rounded-circle"><i className="fas fa-plus rounded-circle"></i></button>
            </Card.Title>

            <Accordion.Collapse in={toggleChild} className="w-100">
                <form name="experience" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
                    <div className="row mb-3">
                        <div className="col-lg-4 col-md-12">
                            <div className="form-group">
                                <label>First Name Only<span className="text-danger">*</span></label>
                                <input className="form-control" type="text" name="name" value={formField.name} onChange={this.handleChange} placeholder="Name" />
                                {this.validator.message('name', formField.name, 'required')}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="form-group">
                                <label>Age<span className="text-danger">*</span></label>
                                <select className="form-control" type="text" name="age" value={formField.age} onChange={this.handleChange} placeholder="Age" >
                                    { ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'] .map(itemAge =>
                                        <option value={itemAge}>{itemAge}</option>
                                    )}
                                </select>
                                {this.validator.message('age', formField.age, 'required')}
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="form-group">
                                <label>Grade<span className="text-danger">*</span></label>
                                <select className="form-control" type="text" name="grade" value={formField.grade} onChange={this.handleChange} placeholder="Grade" >
                                { ['Pre-K', 'K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] .map(item =>
                                    <option value={item}>{item}</option>
                                 )}
                                </select>
                                {this.validator.message('grade', formField.grade, 'required')}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="add-button d-flex justify-content-between"> 
                                <LaddaButton className={`btn btn-primary ${(item === null) ? 'btn-primary mr-3' : 'btn-success'}`} loading={childs.loading} data-style={EXPAND_RIGHT}>{(item === null) ? 'Add' : 'Update'}</LaddaButton>
                                <button className="btn btn-link border-0 " onClick={this.resetForm}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </Accordion.Collapse>

            <ul className="list-group">

                {childItems && childItems.map(item =>
                    (<li key={`child-${item.id}`} className="list-group-item d-flex justify-content-between">
                        <div className="row">
                            <div className="col-10">
                                <h6 className="col pl-0">{item.name}</h6>
                                <p className="text">Grade: {item.grade}</p>
                            </div>
                            <div className="button col-2 text-right">
                                <button className="btn bg-primary rounded-circle px-2 py-1 mx-1 float-right" onClick={() => this.onDelete(item.id)}><i
                                    className="far fa-trash-alt text-white"></i></button>
                                <button className="btn bg-info rounded-circle px-2 py-1 mx-1 float-right" onClick={() => this.onEdit(item)}><i className="fas fa-pencil-alt text-white"></i></button>

                            </div>
                        </div>
                    </li>)
                )}

                {((childItems && childItems.length === 0) && (childItems.loading === false)) &&
                    <div className="pl-2">Subject not found</div>
                }

            </ul>

            {/* <div className="row">
                <div className="form-group col-lg-12 col-md-12">
                    <h3 className="page-subtitle">Kids Information</h3>
                </div>
                    
                <div className="form-group col-lg-6 col-md-12">
                    <label>First Name<span className="text-danger">*</span></label> 
                    <input type="email"className="form-control" placeholder="jon"/>
                </div>
                <div className="form-group col-lg-6 col-md-12">
                    <div className="edit-button"> 
                        <button className="btn bg-info rounded-circle px-2 py-1"><img width="15px" src="/images/svg/edit-pencil.svg"/></button>     
                        <button className="btn bg-primary rounded-circle px-2 py-1"><img width="15px" src="/images/svg/trash.svg"/></button>
                    </div>
                </div>
                <div className="form-group col-lg-6 col-md-12">
                    <label>First Name<span className="text-danger">*</span></label> 
                    <input type="email"className="form-control" placeholder="Emma"/>
                </div>
                <div className="form-group col-lg-6 col-md-12">
                    <div className="add-button d-flex justify-content-between"> 
                        <button className="btn btn-primary ">Add Name</button> 
                        <button className="btn btn-link border-0 ">cancel</button>    
                        <button className="btn btn-add"><i className="fas fa-plus"></i></button>
                    </div>
                </div>
            </div> */}

        </div>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const childsSelector = createSelector(
    state => state.childs,
    childs => childs
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    childsSelector,
    (process, authentication, childs) => ({
        process, authentication, childs
    })
);

export default connect(mapStateToProps)(Kids);
